/** How many choice cells to a row on the item sheet: all of them up to four; past that, rows
 *  as even as they'll go, so five is three and two, not four and one (Oct 2026). */
export function cellColumns(n) {
  if (n <= 4) return Math.max(n, 1);
  if (n % 4 === 0) return 4;
  if (n % 3 === 0 || n < 7) return 3;
  return 4;
}
